(() => {
  const requests = new Map();
  let revision = 0;
  const productKey = card => card.dataset.rbProductId || card.querySelector('h3 a')?.getAttribute('href');
  const firstUrl = grid => {
    const url = new URL(grid.dataset.rbFeed, location.origin);
    url.searchParams.set('view', grid.dataset.rbRecent === 'true' ? 'rb-fresh' : 'rb-showcase');
    url.searchParams.set('sort_by', grid.dataset.rbRecent === 'true' ? 'created-descending' : 'price-descending');
    url.searchParams.set('filter.v.availability', '1');
    return url;
  };
  const page = url => {
    if (url.origin !== location.origin) return Promise.reject(new Error('Unexpected collection origin'));
    if (!requests.has(url.href)) requests.set(url.href, fetch(url).then(response => {
      if (!response.ok) throw new Error('Collection unavailable');
      return response.text();
    }).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('[data-rb-results]')) throw new Error('Collection fragment unavailable');
      const next = doc.querySelector('[data-rb-next]')?.getAttribute('data-rb-next');
      return {cards:[...doc.querySelectorAll('[data-rb-results] .rb-card')],next:next?new URL(next,url):null};
    }).catch(error => { requests.delete(url.href); throw error; }));
    return requests.get(url.href);
  };
  const refresh = async () => {
    const current = ++revision;
    const grids = [...document.querySelectorAll('[data-rb-feed]')];
    if (!grids.length) return;
    const initial = grids.map(grid => [...grid.querySelectorAll('.rb-card')]);
    // Liquid also excludes repeats when JavaScript is disabled.
    const feeds = await Promise.all(grids.map((grid,i) => page(firstUrl(grid)).catch(() => ({cards:initial[i],next:null}))));
    const used = new Set();
    const rows = [];
    for (let i=0;i<grids.length;i++) {
      const selected = [];
      const visited = new Set();
      let feed = feeds[i];
      for (let n=0;n<10;n++) {
        for (const card of feed.cards) {
          const key = productKey(card);
          if (!key || used.has(key)) continue;
          used.add(key);
          selected.push(card.cloneNode(true));
          if (selected.length >= Number(grids[i].dataset.rbLimit)) break;
        }
        if (selected.length >= Number(grids[i].dataset.rbLimit) || !feed.next || visited.has(feed.next.href)) break;
        visited.add(feed.next.href);
        try { feed = await page(feed.next); } catch (_) { break; }
      }
      rows.push(selected);
    }
    if (current !== revision) return;
    // Commit all rows together so request timing cannot create duplicates.
    grids.forEach((grid,i) => {
      grid.replaceChildren(...rows[i]);
      grid.dataset.rbLoaded = 'true';
      grid.closest('.rb-showcase')?.toggleAttribute('hidden',rows[i].length===0);
    });
  };
  refresh();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',refresh);
  document.addEventListener('shopify:section:reorder',refresh);
})();
